// src/redux/features/countryApi.ts

import { api } from '../services/api';
import { countryURL } from '../../components/Data/baseURL';

export interface Country {
  id?: number | string;
  uf?: string;
  label: string;
  value: string;
  code?: string;

  [key: string]: unknown;
}

interface PaginatedCountriesResponse {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results: Country[];
}

const isCountryArray = (response: unknown): response is Country[] => {
  return Array.isArray(response);
};

const isPaginatedCountriesResponse = (response: unknown): response is PaginatedCountriesResponse => {
  return (
    typeof response === 'object' &&
    response !== null &&
    'results' in response &&
    Array.isArray((response as PaginatedCountriesResponse).results)
  );
};

export const countryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCountries: builder.query<Country[], void>({
      query: () => ({
        url: countryURL,
        method: 'GET',
        cache: 'no-store',
      }),

      transformResponse: (response: unknown): Country[] => {
        // console.log('RAW COUNTRIES RESPONSE:', response);

        if (isCountryArray(response)) {
          return response;
        }

        if (isPaginatedCountriesResponse(response)) {
          return response.results;
        }

        console.warn('Unexpected countries response:', response);

        return [];
      },

      providesTags: ['Countries'],
    }),
  }),

  overrideExisting: false,
});

export const { useGetCountriesQuery } = countryApi;
